import * as ARS from "../ars_ldm";
import { type AnnotationVariable } from "../contexts/interface";

export enum ArsSidebarItemKind {
  AnalysisMethod = "analysisMethod",
  GroupingFactor = "groupingFactor",
  Operation = "operation",
  Variable = "variable",
}

/**
 * Sidebar items
 */
export interface ArsSidebarItemAnalysisMethod extends Record<string, unknown> {
  kind: ArsSidebarItemKind.AnalysisMethod;
  dropItem: ARS.AnalysisMethod;
}
export interface ArsSidebarItemGroupingFactor extends Record<string, unknown> {
  kind: ArsSidebarItemKind.GroupingFactor;
  dropItem: ARS.GroupingFactor;
}
export interface ArsSidebarItemOperation extends Record<string, unknown> {
  kind: ArsSidebarItemKind.Operation;
  dropItem: ARS.Operation;
  analysisMethodId: string;
}
export interface ArsSidebarItemVariable extends Record<string, unknown> {
  kind: ArsSidebarItemKind.Variable;
  dropItem: AnnotationVariable;
}

/**
 * Discriminated union type for sidebar item data, supporting grouping factors,
 * analysis methods, operations, and variables.
 */
export type ArsSidebarItemData =
  | ArsSidebarItemAnalysisMethod
  | ArsSidebarItemGroupingFactor
  | ArsSidebarItemOperation
  | ArsSidebarItemVariable;
